module.exports = __webpack_public_path__ + "media/images/covid/menu/shops-7859973cd6c14c0d360e69dace0c4259.png";